import { ChargingStationDto } from "@dto/chargingStationDto";
import { BidiMode } from "./bidiMode";
import { Blackbox } from "./blackbox";
import { ChargingStation } from "./charging-station";

export class BidiConfiguration {
  id: string;
  gatewayId: number;
  gateway: Blackbox | null;
  bidiModeId: string;
  bidiMode: BidiMode;
  targetPowerInWatt: number;
  minSoc: number;
  maxSoc: number
  chargingStations: ChargingStation[] | null;

  constructor(data?: Partial<BidiConfiguration>) {
    if (data) {
      Object.assign(this, data);
    }
  }
}